<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <Breadcrumbs :links="links" />

        <div class="actions level">
          <div class="level-left">
            &nbsp;
          </div>
          <div class="level-right">
            <div class="mr-15"><InformationOutline />&nbsp;{{ filteredSubmissions.length }} submissions</div>

            <div class="dropdown is-hoverable is-right mr-15">
              <div class="dropdown-trigger">
                <button class="button is-dark is-small" aria-haspopup="true" aria-controls="event-dropdown">
                  <span>{{ event.name }}</span>
                  <span>
                    <ChevronDown />
                  </span>
                </button>
              </div>
              <div class="dropdown-menu" id="event-dropdown" role="menu">
                <div class="dropdown-content">
                  <a
                    v-for="event in events"
                    :key="event._id"
                    href="#"
                    class="dropdown-item"
                    @click.prevent="changeSelectedEvent(event._id)"
                  >
                    {{ event.name }}
                  </a>

                </div>
              </div>
            </div>

            <div class="dropdown is-hoverable is-right mr-15">
              <div class="dropdown-trigger">
                <button class="button is-dark is-small" aria-haspopup="true" aria-controls="division-dropdown">
                  <span><b>Division:</b> {{ selectedDivision.name }}</span>
                  <span>
                    <ChevronDown />
                  </span>
                </button>
              </div>
              <div class="dropdown-menu" id="division-dropdown" role="menu">
                <div class="dropdown-content">
                  <a
                    href="#"
                    class="dropdown-item"
                    @click.prevent="filterDivisions('all')"
                  >All</a>
                  <a
                    v-for="division in divisions"
                    :key="division._id"
                    href="#"
                    class="dropdown-item"
                    @click.prevent="filterDivisions(division._id)"
                  >
                    {{ division.name }}
                  </a>
                </div>
              </div>
            </div>

            <!--div class="custom-toggle">
              <span
                v-tooltip="'Select to only show submissions that have been scored'"
                class="custom-label tooltip-hint"
              >With scores</span>
              <input
                id="completedToggle"
                :checked="scoredOnly"
                type="checkbox"
                name="completedToggle"
                class="custom-control-input"
                @click="toggleScored"
              >
              <label
                class="custom-control-label mt-2"
                for="completedToggle"
              />
            </div-->

            <div class="dropdown is-hoverable is-right mr-15">
              <div class="dropdown-trigger">
                <button class="button is-dark is-small" aria-haspopup="true" aria-controls="score-dropdown">
                  <span><b>Status:</b> Any</span>
                  <span>
                    <ChevronDown />
                  </span>
                </button>
              </div>
              <div class="dropdown-menu" id="score-dropdown" role="menu">
                <div class="dropdown-content">
                  <a
                    href="#"
                    class="dropdown-item"
                    @click.prevent="filterScores('all')"
                  >Any</a>
                  <a
                    href="#"
                    class="dropdown-item"
                    @click.prevent="filterScores('scored')"
                  >Scored</a>
                  <a
                    href="#"
                    class="dropdown-item"
                    @click.prevent="filterScores('not-scored')"
                  >Not scored</a>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div
          v-if="filteredSubmissions.length > 0"
        >
        <br>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>User</th>
              <th>Division</th>
              <th>
                Score&nbsp;
                <a
                  href="#"
                  v-tooltip="'Sort by score. Default will sort by descending submission date.'"
                  @click.prevent="sortScores"
                >
                  <Sort v-if="scoreSort === ''" />
                  <SortAscending v-else-if="scoreSort === 'asc'" />
                  <SortDescending v-else />
                </a>
              </th>
              <th>Submit Date</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <SubmissionRow
              v-for="submission in filteredSubmissions"
              :key="submission.fileName"
              :submission="submission"
              @viewVideo="toggleVideoModal"
              @viewScores="toggleScoresModal"
              @reloadSubmission="getSubmissions"
            />
          </tbody>
        </table>

        </div>
        <div
          v-else
          class="empty-dashboard"
        >
          <h1 class="is-size-3">No submissions found</h1>
          <br>
          <img src="@/assets/svg/empty.svg" alt="">
        </div>
      </div>
    </div>
    <VideoModal
      v-if="openVideoModal"
      :is-open="openVideoModal"
      :file-name="fileName"
      :youtube-id="youtubeId"
      @closeModal="toggleVideoModal"
    />
    <ScoresModal
      v-if="openScoresModal"
      :is-open="openScoresModal"
      :scores="scores"
      @closeModal="toggleScoresModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InformationOutline from 'vue-material-design-icons/InformationOutline.vue'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import Sort from 'vue-material-design-icons/Sort.vue'
import SortDescending from 'vue-material-design-icons/SortDescending.vue'
import SortAscending from 'vue-material-design-icons/SortAscending.vue'
const Breadcrumbs = () => import('@/components/admin/Breadcrumbs')
const SubmissionRow = () => import('@/components/admin/submissions/SubmissionRow')
const VideoModal = () => import('@/components/modals/VideoModal')
const ScoresModal = () => import('@/components/modals/ScoresModal')

export default {
  name: 'Submissions',
  metaInfo: {
    title: `Submissions - ${process.env.VUE_APP_PAGE_TITLE}`
  },
  components: {
    Breadcrumbs,
    SubmissionRow,
    VideoModal,
    ScoresModal,
    InformationOutline,
    ChevronDown,
    Sort,
    SortDescending,
    SortAscending
  },
  data () {
    return {
      openVideoModal: false,
      openScoresModal: false,
      fileName: '',
      youtubeId: '',
      scores: [],
      divisions: [],
      selectedDivision: {
        name: 'All'
      },
      scoreStatus: 'all',
      scoreSort: '',
      links: [
        {
          label: 'Dashboard',
          routeName: 'admin-dashboard',
          isActive: false,
          icon: 'dashboard'
        },
        {
          label: 'Submissions',
          routeName: 'admin-submissions',
          isActive: true,
          icon: 'video'
        }
      ]
    }
  },
  mounted () {
    if (this.submissions.length === 0) {
      this.getSubmissions()
      console.log(this.submission);
    }
    if (this.divisions.length === 0) {
      this.getDivisions()
    }
  },
  computed: {
    ...mapGetters('submissions', [
      'submissions'
    ]),
    filteredSubmissions () {
      let subs = this.submissions

      if (this.scoreStatus === 'scored') {
        subs = this.submissions.filter(item => {
          return item.scores.length > 0
        })
      } else if (this.scoreStatus === 'not-scored') {
        subs = this.submissions.filter(item => {
          return item.scores.length === 0
        })
      } else {
        subs = this.submissions
      }

      if (this.scoreSort === '') {
        subs = subs.sort((a, b) => {
          return new Date(b.submitDate) - new Date(a.submitDate)
        })
      } else if (this.scoreSort === 'asc') {
        subs = subs.sort((a, b) => {
          return a.finalScore - b.finalScore
        })
      } else if (this.scoreSort === 'des') {
        subs = subs.sort((a, b) => {
          return b.finalScore - a.finalScore
        })
      }

      return subs
    },
    currentUser () {
      return this.$store.getters['users/currentUser']
    },
    events () {
      return this.$store.getters.events
    },
    event () {
      return this.$store.getters.currentEvent
    }
  },
  watch: {
    event () {
      this.getDivisions()
      this.getSubmissions()
    },
    selectedDivision () {
      this.getSubmissions()
    }
  },
  methods: {
    toggleVideoModal (data) {
      if (typeof data !== 'undefined') {
        this.fileName = data.fileName
        this.youtubeId = data.youtubeId
      }
      this.openVideoModal = !this.openVideoModal
    },
    toggleScoresModal (scores) {
      this.scores = scores
      this.openScoresModal = !this.openScoresModal
    },
    getSubmissions () {
      this.$store
        .dispatch('submissions/GET_SUBMISSIONS', {
          eventId: this.event._id
        })
        .then(res => {
          this.count = res.data.length

          this.$store.dispatch('submissions/saveSubmissions', res.data)
        })
    },
    getDivisions () {
      this.$store
        .dispatch('register/GET_DIVISION', { eventId: this.event._id })
        .then(res => {
          this.divisions = res.data.divisions
        })
    },
    changeSelectedEvent (eventId) {
      let selectedEvent = this.events.filter(item => {
        return item._id === eventId
      })[0]
      this.$store.commit('saveEvent', selectedEvent)
    },
    filterDivisions (value) {
      if (value !== 'all') {
        this.$store.commit('submissions/saveFilter', value)
        this.selectedDivision = this.divisions.filter(item => {
          return item._id === value
        })[0]
      } else {
        this.$store.commit('submissions/saveFilter', 'all')
        this.selectedDivision = {
          name: 'All'
        }
      }
    },
    filterScores (status) {
      this.scoreStatus = status
    },
    sortScores () {
      switch (this.scoreSort) {
        case '':
          this.scoreSort = 'des'
          break

        case 'des':
          this.scoreSort = 'asc'
          break

        case 'asc':
          this.scoreSort = ''
          break
      }
    }
  }
}
</script>
